import React from 'react'
// import Link from 'next/link';

export default function PageHeader ({ customClassName = 'px-3 mb-3', title, pageActions, pageInfo }) {
  return (
    <div className={customClassName}>
      {/* <Breadcrumb>
        <Breadcrumb.Item><Link href='/'><a>Home</a></Link></Breadcrumb.Item>
      </Breadcrumb> */}
      <div className='row justify-content-between'>
        <div style={{ fontWeight: '600', fontSize: '32px', lineHeight: '40px', color: '#121315' }}>{title}</div>
        {pageActions && (
          <div>{pageActions}</div>
        )}
      </div>
      <div>{pageInfo}</div>
    </div>
  )
}
